/**
 * Returns a stable media slot URL for an image subject.
 *
 * Passing dimensions asks the delivery layer for a cropped, right-sized
 * rendition while preserving the stable slot URL used by visual editing.
 * Never substitute direct CDN URLs: those bypass slot management.
 */
export function imgSrc(
  slot: string,
  options?: { width: number; height?: number; fit?: 'crop' | 'contain' },
): string {
  const url = `/airo-assets/images/${slot}`;
  if (!options) return url;

  const params = new URLSearchParams({ width: String(options.width) });
  if (options.height) params.set('height', String(options.height));
  if (options.fit) params.set('fit', options.fit);
  return `${url}?${params.toString()}`;
}
